import React from 'react';
import { Fragment, useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { Row, Alert } from 'react-bootstrap';
import FormBusca from './form_busca';
import RHService from '../../../../../services/rh-auth';
import Terceirizado from './terceirizado';


const ListarTerceirizado = () => {

    const [terceirizados, setTerceirizados] = useState([]);
    const [editar, setEditar] = useState("");
    const [vazio, setVazio] = useState(false);
    const [empresas, setEmpresas] = useState([]);
    const [terc, setTerc] = useState("");


    async function fetchTerceirizados() {
        await montaSelectEmpresas()
        const response = await RHService.listarTerceirizados();
        if (response.data.length >= 1) {
            setTerceirizados(response.data)
            setVazio(false)
        } else {
            setTerceirizados([])
            setVazio(true)
        }
    }

    const montaSelectEmpresas = async () => {
        const prod = await RHService.listarTerceirizados();
            setEmpresas(prod.data)
    }

    const handleEditar = (id) => {
        setTerc(id);
        setEditar(true)
    }


    const deletar = async (id) => {
        if (window.confirm('Tem certeza que deseja deletar o Terceirizado?')) {
            await RHService.deletarTerceirizados(id)
            alert("Terceirizado deletado com sucesso!")
            fetchTerceirizados();
        }
    }

    useEffect(() => {
        fetchTerceirizados();
    }, []);



    if (editar) {
        return (
            <Navigate to={`/restrito/rh/terceirizado/editar/${terc}`} />
        )
    }
    else {
        return (
            <Fragment>
                <Fragment>
                    <FormBusca
                        setTerceirizados={setTerceirizados}
                        setVazio={setVazio}
                        empresas={empresas}
                        fetchTerceirizados={fetchTerceirizados}
                    />
                </Fragment>
                {vazio ? <Fragment>
                    <Alert variant='danger'>Sua busca não gerou nenhum resultado :(</Alert>
                </Fragment> :
                    <Fragment>
                        <Row xs={3}>
                            {terceirizados.map((terc, index) =>
                                <Terceirizado
                                    fetchTerceirizados={fetchTerceirizados}
                                    terc={terc}
                                    key={index}
                                    editar={handleEditar}
                                    deletar={deletar}
                                />
                            )}
                        </Row>
                    </Fragment>}
            </Fragment>

        )
    }
}

export default ListarTerceirizado;